import { Reveal } from "@/components/Reveal";
import { useTranslation } from "react-i18next";

const DEFAULT_QUOTES = [
    {
        q: "I've deleted three travel apps since I got Passport. It's like Instagram and a moleskine had a very well-designed baby.",
        n: "Amelia Reeve",
        t: "Photographer, London",
        avatar: "https://images.unsplash.com/photo-1614709445081-23465e205471?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxwb3J0cmFpdCUyMGRpdmVyc2UlMjBsdXh1cnl8ZW58MHx8fHwxNzg0NjczMzk2fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        q: "The AI planner talked me out of an expensive hotel and into a family-run riad in the Fez medina. Best two days of the trip.",
        n: "Daniyar Amankeldi",
        t: "Product designer, Almaty",
        avatar: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&h=200&fit=crop",
    },
    {
        q: "TravelDate designed our anniversary and I have not stopped talking about the rooftop it picked in Bogotá.",
        n: "Jordan Okafor",
        t: "Writer, New York",
        avatar: "https://images.unsplash.com/photo-1714663843788-aa2a7e6f353d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxwb3J0cmFpdCUyMGRpdmVyc2UlMjBsdXh1cnl8ZW58MHx8fHwxNzg0NjczMzk2fDA&ixlib=rb-4.1.0&q=85",
    },
];

const METRICS_CONFIG = [
    { n: "2.4M+", key: "travelers", defaultLabel: "Travelers on board" },
    { n: "195", key: "countries", defaultLabel: "Countries mapped" },
    { n: "18M", key: "stamps", defaultLabel: "Stamps collected" },
    { n: "740k", key: "reviews", defaultLabel: "Reviews written" },
    { n: "12k+", key: "partners", defaultLabel: "Business partners" },
];

export default function Testimonials() {
    const { t } = useTranslation();
    const localizedQuotes = t("testimonials.quotes", { returnObjects: true });
    const quotes = Array.isArray(localizedQuotes)
        ? localizedQuotes.map((item, idx) => ({ ...DEFAULT_QUOTES[idx], ...item }))
        : DEFAULT_QUOTES;

    return (
        <section className="relative py-32 md:py-40" data-testid="testimonials">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <Reveal>
                    <div className="grid md:grid-cols-2 gap-8 items-end mb-16">
                        <div>
                            <div className="overline mb-4">{t("testimonials.overline")}</div>
                            <h2 className="font-serif text-5xl md:text-7xl text-white leading-[0.95] tracking-tighter">
                                A community of <span style={{ fontStyle: "italic", color: "var(--gold-pale)" }}>{t("testimonials.habitualExplorers")}</span>.
                            </h2>
                        </div>
                    </div>
                </Reveal>

                <div className="grid md:grid-cols-3 gap-6 mb-24">
                    {quotes.map((q, i) => (
                        <Reveal key={i} delay={0.05 * i}>
                            <figure className="rounded-3xl p-8 h-full flex flex-col justify-between card-hover" style={{ background: "var(--navy-deep)", border: "1px solid rgba(255,255,255,0.06)" }} data-testid={`quote-${i}`}>
                                <blockquote className="font-serif text-2xl md:text-[26px] text-white leading-[1.25] mb-10">
                                    <span style={{ color: "var(--gold)", fontFamily: "var(--font-serif)" }}>&ldquo;</span>
                                    {q.q}
                                    <span style={{ color: "var(--gold)" }}>&rdquo;</span>
                                </blockquote>
                                <figcaption className="flex items-center gap-3">
                                    <img src={q.avatar} alt={q.n} className="w-11 h-11 rounded-full object-cover" style={{ border: "1px solid rgba(212,175,55,0.4)" }} />
                                    <div>
                                        <div className="text-white text-sm">{q.n}</div>
                                        <div className="text-white/50 text-xs">{q.t}</div>
                                    </div>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>

                <Reveal>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-8 pt-12 border-t" style={{ borderColor: "rgba(255,255,255,0.06)" }}>
                        {METRICS_CONFIG.map((m) => (
                            <div key={m.key} data-testid={`metric-${m.key}`}>
                                <div className="font-serif text-4xl md:text-5xl text-white leading-none">{m.n}</div>
                                <div className="text-[10px] tracking-[0.2em] uppercase text-white/50 mt-3">
                                    {t(`testimonials.metrics.${m.key}`, m.defaultLabel)}
                                </div>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
